import { getJson } from './baseApi'

export const fetchAllowedVerificationTypeGroups = () => {
	return getJson('/api/verification/allowedVerificationTypeGroups')
}